import {IQaRegistrationRegistrationStep } from "../../../models/index";

export interface IQaRegistrationState {
    QaRegistrationSteps: IQaRegistrationRegistrationStep[];
    QaPwlSteps: IQaRegistrationRegistrationStep[];
    StepUrl: string;
}